import { render, staticRenderFns } from "./LogoTitle.vue?vue&type=template&id=95d32290&scoped=true&"
import script from "./LogoTitle.vue?vue&type=script&lang=ts&"
export * from "./LogoTitle.vue?vue&type=script&lang=ts&"
import style0 from "./LogoTitle.vue?vue&type=style&index=0&id=95d32290&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d32290",
  null
  
)

export default component.exports